import { MarketDialog } from '@market/react';
import { BankingModalBase, type BankingModalBaseProps } from './BankingModalBase';

/**
 * Dialog component for Banking that provides consistent styling and structure.
 * This uses MarketDialog which is a compact centered dialog, ideal for
 * confirmations and simple actions.
 *
 * The content of the dialog can be a string, which will be used in a paragraph
 * tag. This dialog supports complex content by allowing it to also be a ReactNode.
 *
 * Example:
 * const Content = <div>Custom content here</div>;
 *
 * <BankingDialog {...props} content={Content}/>
 *
 * Buttons in Banking dialogs use "fill" alignment to span the full width.
 */

export type BankingDialogProps = Omit<BankingModalBaseProps, 'ModalWrapper'>;

export const BankingDialog = (props: BankingDialogProps) => (
  <BankingModalBase {...props} ModalWrapper={MarketDialog} />
);
